import { render, staticRenderFns } from "./WorkIdentity.vue?vue&type=template&id=cfd45af0"
import script from "./WorkIdentity.vue?vue&type=script&lang=js"
export * from "./WorkIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports